import { Controller } from "@hotwired/stimulus";

// Controls the interactive launch checklist in the dashboard.
// Allows users to click on any step to view its details and CTA.
export default class extends Controller {
  static targets = ["step", "panel"];
  static values = {
    current: String,
  };

  connect() {
    // Show the initial step panel
    this.showPanel(this.currentValue);

    // Reload when the user returns after being away (another tab, etc.),
    // so the checklist reflects any steps completed elsewhere.
    this.hiddenAt = null;
    this.boundHandleVisibility = this.handleVisibilityChange.bind(this);
    this.boundHandlePageShow = this.handlePageShow.bind(this);
    document.addEventListener("visibilitychange", this.boundHandleVisibility);
    window.addEventListener("pageshow", this.boundHandlePageShow);
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.boundHandleVisibility);
    window.removeEventListener("pageshow", this.boundHandlePageShow);
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.hiddenAt = Date.now();
    } else if (this.hiddenAt) {
      // Only reload if we were hidden for more than 5 seconds —
      // long enough that a step may have been completed elsewhere.
      if (Date.now() - this.hiddenAt > 5000) {
        window.location.reload();
      }
      this.hiddenAt = null;
    }
  }

  // Turbo-powered navigation back to this page (bfcache restore).
  handlePageShow(event) {
    if (event.persisted) {
      window.location.reload();
    }
  }

  select(event) {
    const step = event.currentTarget.dataset.step;
    this.currentValue = step;
    this.showPanel(step);
  }

  showPanel(step) {
    // Update step highlights
    this.stepTargets.forEach((el) => {
      const isSelected = el.dataset.step === step;
      el.classList.toggle("ring-2", isSelected);
      el.classList.toggle("ring-emerald-500", isSelected);
    });

    // Show the correct panel
    this.panelTargets.forEach((el) => {
      const isVisible = el.dataset.step === step;
      el.classList.toggle("hidden", !isVisible);
    });
  }

  skip(event) {
    event.preventDefault();
    // Find the next incomplete step after the current one
    const steps = [
      "notifications",
      "setup",
      "custom_voice",
      "integrations",
      "plan",
      "telephony",
      "agents",
    ];
    const currentIndex = steps.indexOf(this.currentValue);

    // Move to next step
    if (currentIndex < steps.length - 1) {
      const nextStep = steps[currentIndex + 1];
      this.currentValue = nextStep;
      this.showPanel(nextStep);
    }
  }
}
